var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShortIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6291 11.8437L7.00202 17.2726C6.93126 17.344 6.84407 17.4013 6.74628 17.4405C6.64849 17.4797 6.54236 17.5 6.43499 17.5C6.32762 17.5 6.22148 17.4797 6.12369 17.4405C6.0259 17.4013 5.93871 17.344 5.86795 17.2726C5.85993 17.2641 5.85672 17.2527 5.8487 17.2442L0.234491 11.8437C0.0833494 11.6915 0 11.4958 0 11.2932C0 11.0906 0.0833494 10.8949 0.234491 10.7426C0.237699 10.7412 0.242511 10.7398 0.245719 10.737C0.31647 10.6635 0.404197 10.6044 0.502983 10.5635C0.601768 10.5226 0.709315 10.501 0.818368 10.5H12.0468C12.2762 10.5 12.4799 10.5965 12.6259 10.7455L12.6291 10.7426C12.9435 11.0477 12.9435 11.5401 12.6291 11.8437Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.70703C0.5 6.64487 0.52491 6.57338 0.588867 6.50879L6.19531 1.11621L6.21289 1.09863C6.22186 1.08911 6.22806 1.07822 6.23535 1.06934C6.25456 1.05265 6.27876 1.03581 6.30957 1.02344C6.34692 1.00846 6.38987 1.00005 6.43457 1C6.47942 1 6.52308 1.00841 6.56055 1.02344C6.5977 1.03838 6.62619 1.05868 6.64648 1.0791L6.65527 1.08691L12.2812 6.51562C12.3774 6.60852 12.3909 6.74719 12.3184 6.85352L12.2686 6.9043C12.2094 6.96466 12.1318 6.99998 12.0469 7L0.823242 7C0.777029 6.99958 0.732658 6.99044 0.694336 6.97461C0.656003 6.95875 0.626145 6.93747 0.605469 6.91602L0.591797 6.90137L0.577148 6.88867C0.575791 6.88747 0.573621 6.88692 0.572266 6.88574C0.521035 6.82636 0.500053 6.76323 0.5 6.70703Z",
    fill: "#DBDBDB",
    stroke: "#949495"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShortIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ShortIcon.8d4501b91a03cf6a09c7c42186b24b56.svg";